import { useEffect, useRef } from "react";
import { plugAndBarFeatures } from "@/mocks/home";

export default function PlugAndBarSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    const section = sectionRef.current;
    if (section) {
      const elements = section.querySelectorAll(".animate-on-scroll");
      elements.forEach((el) => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-14 md:py-20 bg-gradient-to-b from-background-50 to-background-100">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16 animate-on-scroll opacity-0 translate-y-6 transition-all duration-700">
          <div className="bg-background-950 rounded-2xl px-8 py-4 inline-block">
            <img
              src="https://storage.readdy-site.link/project_files/2f83d064-4368-49c5-aa2e-85e52f732183/9933f1da-da20-4927-b49b-ad25a79d2710_plug-and-bar.png?v=917509636eff9f4c4c7c9450351ff3b8"
              alt="Plug and Bar"
              className="mx-auto w-auto h-16 md:h-20 object-contain"
            />
          </div>
          <div className="w-24 h-1 bg-primary-500 mx-auto rounded-full mt-4"></div>
        </div>
        <div className="flex flex-col md:flex-row items-center justify-between gap-10">
          <div className="w-full md:w-1/2 animate-on-scroll opacity-0 translate-y-6 transition-all duration-700">
            <img
              src="https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/ddc3086680834f98f04978f408fbedf3.jpeg"
              alt="Plug & Bar"
              className="rounded-lg shadow-2xl w-full h-auto object-cover"
              style={{ maxHeight: "500px" }}
            />
          </div>
          <div className="w-full md:w-1/2 px-6 md:px-0 animate-on-scroll opacity-0 translate-y-6 transition-all duration-700 delay-150">
            <p className="text-foreground-50 mb-8 text-base md:text-lg leading-loose md:leading-relaxed max-w-xl mx-auto md:mx-0">
              Complétez votre événement avec{" "}
              <span className="text-primary-500 font-semibold whitespace-nowrap">
                Plug and Bar
              </span>
              , nos remorques-bars mobiles{" "}
              <span className="text-primary-500 font-semibold whitespace-nowrap">
                conçues pour performer
              </span>
              . Elles s'adaptent parfaitement pour festivals, manifestations, événements d'entreprise, mariages, événements privés et activations de marques.
            </p>
            <ul className="space-y-4 mb-8 max-w-xl mx-auto md:mx-0">
              {plugAndBarFeatures.map((feature) => (
                <li key={feature} className="flex items-start">
                  <span className="text-primary-500 font-bold mt-1 mr-3 flex-shrink-0">✓</span>
                  <p className="text-foreground-50 leading-relaxed">{feature}</p>
                </li>
              ))}
            </ul>
            <div className="flex justify-center md:justify-start">
              <a
                href="https://plugandbar.ch/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-primary-500 text-background-50 font-semibold px-8 py-3 rounded-lg whitespace-nowrap hover:bg-primary-600 transition-all duration-300"
              >
                Découvrir Plug and Bar
              </a>
            </div>
          </div>
        </div>
      </div>
      <style>{`
        .animate-in {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>
    </section>
  );
}